import script from "./ChallengeActivity.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChallengeActivity.vue?vue&type=script&setup=true&lang=ts"

import "./ChallengeActivity.vue?vue&type=style&index=0&id=1d93fd7c&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1140266145/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d93fd7c"]])

export default __exports__